import { configure } from '@zip.js/zip.js';
configure({
    useCompressionStream: true,
    useWebWorkers: false,
});
export * from "./FileCollection.js";
export { CURRENT_IUM_VERSION } from './ium/versions/index.js';
/**
 * Tools using this package can configure zip.js with the following `zipJsConfigure` method
 *
 * The default configuration from FileCollection is:
 * ```ts
 * configure({
 *   useCompressionStream: true,
 *   useWebWorkers: false,
 * });
 * ```
 * @see https://github.com/gildas-lormeau/zip.js/tree/master/dist
 */
export { configure as zipJsConfigure } from '@zip.js/zip.js';
//# sourceMappingURL=index.js.map